import { Alert, Link } from '@amzn/awsui-components-core';
import { ContentAudience } from '@amzn/awscat-pattern-library-service-model';
import React, { ReactElement } from 'react';
import constants from '../../common/constants';

interface Props {
  contentAudience?: ContentAudience;
  visible?: boolean;
  text?: string;
  alertLevel?: 'warning' | 'info';
}

const NoticeOfPublication: React.FunctionComponent<Props> = (props: Props) => {
  const { contentAudience, text, visible, alertLevel } = props;
  if (!visible) {
    return null;
  }

  let content: ReactElement | null = null;

  if (text) {
    content = <Alert type={alertLevel === 'warning' ? 'warning' : 'info'}>{text}</Alert>;
  } else if (contentAudience === ContentAudience.PUBLIC) {
    content = (
      <Alert
        type={alertLevel === 'warning' ? 'warning' : 'info'}
        header={constants.NOTICE_OF_PUBLICATION_HEADER}
      >
        Choosing this option submits your content for potential publication on the{' '}
        <Link variant="primary" href={constants.APG_WEBSITE_URL} target="_blank">
          {' '}
          AWS Prescriptive Guidance{' '}
        </Link>{' '}
        website after it completes the internal review and publication process. The APG team
        evaluates internally published submissions for quality and relevance, and the content must
        be suitable for external audiences and contain no confidential information. Content that is
        not selected for external publishing will remain in the selection pool for later
        reprioritization.
      </Alert>
    );
  }

  return content ? (
    <>
      <br />
      {content}
    </>
  ) : null;
};

export default NoticeOfPublication;
